import {Component, OnInit, ViewChild} from '@angular/core';
import {TestimonialModel} from '../../../../models/testimonial-model';
import {NgbCarousel, NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from "../../../../services/api.service";

@Component({
    selector: 'app-testimonials-section',
    templateUrl: './testimonials-section.component.html',
    styleUrls: ['./testimonials-section.component.scss'],
    providers: [NgbCarouselConfig],
})
export class TestimonialsSectionComponent {

    @ViewChild('carousel', {static: true}) carousel: NgbCarousel;
    public testimonials: TestimonialModel[];

    constructor(private apiService: ApiService,
                private config: NgbCarouselConfig) {
        config.showNavigationIndicators = false;
        config.showNavigationArrows = false;
    }

    async ngOnInit() {
        this.testimonials = await this.apiService.getTestimonials();

    }

    onImageError(event: any, index: number): void {
        // Hide the image element when it fails to load
        event.target.style.display = 'none';
        // Optionally, you could also update the testimonial data to remove the image
        if (this.testimonials && this.testimonials[index]) {
            this.testimonials[index].image = null;
        }
    }
}
